import vNumber from '../directives/v-number'
import vScrollEnd from '../directives/v-scroll-end'

export function registerDirectives(Vue) {
  Vue.directive('number', vNumber)
  Vue.directive('scrollEnd', vScrollEnd)
}
